import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';

export type CompanyIdPropsHook = string[];

export default function useCompanyIdProps(): CompanyIdPropsHook {
  const [query] = useQuery('companies');

  const searchWords = useSearchWords(query);

  return searchWords;
}
